// extracted by mini-css-extract-plugin
module.exports = {"barcode":"styles_barcode__1ckQl","fullHeight":"styles_fullHeight__34j40","minimized":"styles_minimized__gf4KV"};